// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"143":"aa6559a3","237":"835d47ee","341":"bd65b796"}[chunkId] + ".chunk.css";
};